import Immutable from 'immutable';

import Filter from 'sharedreact/data/Filter';
import GroupAndCount from 'sharedreact/data/GroupAndCount';
import SortOrder from 'sharedreact/data/SortOrder';

interface ItemType {
  id: string;
  name?: string;

  get: (key: any) => any;
};

type ItemStateContent<Item, ExtraData> = {
  filter: Filter,
  filterTemp: Filter,
  filterGallery: Filter,
  advancedFilter: Filter,
  filterString: string,
  filterStringGallery: string,
  filterStringTemp: string,
  items: Immutable.List<Item>, // curently visible items
  mappedItems: Immutable.Map<string, NonNullable<Item>>, // all items, mapped id -> Item
  isFetching: boolean,
  hasNotFetchedYet: boolean,
  isAdding: boolean,
  hasReceivedInitialData: boolean,
  countPerGroup: Immutable.List<GroupAndCount>,
  sortOrder: SortOrder,
  selection: Immutable.Set<string>,
  allowMultiSelect: boolean,
  ensureSelectionIsVisible: boolean,
  selectionIndexes: Immutable.Map<string, number>,
  disabledForSelection: Immutable.List<string>,
  showAll: boolean,
  allowSelectionsFromAllGroups: boolean,
  extraData: ExtraData | null
};

function getInitialItemStateContent<Item, ExtraData>(initialSortOrder: SortOrder): ItemStateContent<Item, ExtraData> {
  return {
    filter: new Filter(),
    filterTemp: new Filter(),
    filterGallery: new Filter(),
    advancedFilter: new Filter(),
    filterString: '',
    filterStringGallery: '',
    filterStringTemp: '',
    items: Immutable.List(),
    mappedItems: Immutable.Map(),
    isFetching: false,
    hasNotFetchedYet: true,
    isAdding: false,
    hasReceivedInitialData: false,
    countPerGroup: Immutable.List(),
    sortOrder: initialSortOrder,
    selection: Immutable.Set(),
    allowMultiSelect: false,
    ensureSelectionIsVisible: false,
    selectionIndexes: Immutable.Map(),
    disabledForSelection: Immutable.List(),
    showAll: true,
    allowSelectionsFromAllGroups: false,
    extraData: null
  }
}

type ItemsState<Item, ExtraData = null> = ReturnType<ReturnType<typeof Immutable.Record<ItemStateContent<Item, ExtraData>>>>;

function getInitialItemState<Item, ExtraData = null>(initialSortOrder: SortOrder): ItemsState<Item, ExtraData> {
  return Immutable.Record(getInitialItemStateContent<Item, ExtraData>(initialSortOrder))();
}

export {
  ItemType,
  getInitialItemState
};

export default ItemsState;
